import React, { useState } from "react";
import "../Styles/Mp4.css";

// Pulls the YouTube video ID out of an embed URL so we can build a thumbnail
const extractVideoId = (embedUrl) => {
  const match = embedUrl.match(/embed\/([^?]+)/);
  return match ? match[1] : "";
};

function Mp4() {
  const allVideos = [
    {
      youtube: "https://www.youtube.com/embed/hZRp4_IXkcg?si=4poNLpsDmQT7Bpd1",
      title: "INR New Song | Kandukur",
      channel: "Inturi Nageswara Rao",
      category: "New Song",
      time: "2 days ago",
      views: "12.5K",
      duration: "04:35",
    },
    {
      youtube: "https://www.youtube.com/embed/JJGD1ABTLHE?si=kHldOj6I30Dn3gLa",
      title: "Mass Song: Kandukur Mass Song",
      channel: "Political Box",
      category: "Mass Song",
      time: "5 days ago",
      views: "8.3K",
      duration: "04:12",
    },
    {
      youtube: "https://www.youtube.com/embed/vMg-c3U2HSo?si=X8yZJZJZJZJZJZJZ",
      title: "Yellow Singam | TDP New Song 2024",
      channel: "TV5 News",
      category: "TDP New Song",
      time: "1 week ago",
      views: "25.1K",
      duration: "03:48",
    },
    {
      youtube: "https://www.youtube.com/embed/3f0x8aC9ayA?si=default",
      title: "Chandruda Ra Ra Special Song",
      channel: "Chandrababu Naidu",
      category: "Special Song",
      time: "1 month ago",
      views: "15.2K",
      duration: "04:20",
    },
    {
      youtube: "https://www.youtube.com/embed/Q7Tkdro3Bg4?si=default",
      title: "Inturi Nageswararao Dj Song | Kandukur",
      channel: "Dj Srivardhan Mixes",
      category: "DJ Song",
      time: "2 weeks ago",
      views: "10.7K",
      duration: "03:55",
    },
    {
      youtube: "https://www.youtube.com/embed/xaXd-Z9op14?si=default",
      title: "2020 TDP Kadali Randi Telugu Desa Kavathu",
      channel: "Telugu Desa Kavathu",
      category: "Campaign Song",
      time: "2 months ago",
      views: "22.5K",
      duration: "05:18",
    },
  ];

  const [activeTab, setActiveTab] = useState("All Videos");
  const [search, setSearch] = useState("");
  const [playingIndex, setPlayingIndex] = useState(null);
  const [likedVideos, setLikedVideos] = useState([]);
  const [openMenuIndex, setOpenMenuIndex] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const videosPerPage = 6;

  const tabs = [
    { name: "All Videos", icon: "▶" },
    { name: "Songs", icon: "♫" },
    { name: "Campaigns", icon: "📣" },
    { name: "Events", icon: "📅" },
  ];

  const filteredVideos = allVideos.filter((v) => {
    const matchesTab =
      activeTab === "All Videos" ||
      (activeTab === "Songs" && v.category.toLowerCase().includes("song")) ||
      (activeTab === "Campaigns" &&
        v.category.toLowerCase().includes("campaign")) ||
      (activeTab === "Events" && v.category.toLowerCase().includes("event"));
    const matchesSearch = v.title.toLowerCase().includes(search.toLowerCase());
    return matchesTab && matchesSearch;
  });

  const totalPages = Math.ceil(filteredVideos.length / videosPerPage);
  const startIndex = (currentPage - 1) * videosPerPage;
  const currentVideos = filteredVideos.slice(
    startIndex,
    startIndex + videosPerPage
  );

  const toggleLike = (index) => {
    setLikedVideos((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
    setCurrentPage(1);
  };

  return (
    <section className="video-gallery-section">
      <div className="video-container">
        {/* Heading */}
        <div className="vg-heading-wrap">
          <h1 className="vg-heading">Video Gallery</h1>
          <div className="vg-heading-underline">
            <span></span>
            <span className="vg-underline-dot">●</span>
            <span></span>
          </div>
          <p className="vg-subtitle">
            Watch and enjoy the latest songs, campaigns and highlights
          </p>
        </div>

        {/* Filters + Search */}
        <div className="vg-controls">
          <div className="vg-tabs">
            {tabs.map((tab) => (
              <button
                key={tab.name}
                className={`vg-tab-btn ${
                  activeTab === tab.name ? "active" : ""
                }`}
                onClick={() => handleTabChange(tab.name)}
              >
                <span className="vg-tab-icon">{tab.icon}</span>
                {tab.name}
              </button>
            ))}
          </div>

          <div className="vg-search">
            <span className="vg-search-icon">🔍</span>
            <input
              type="text"
              placeholder="Search videos..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setCurrentPage(1);
              }}
            />
          </div>
        </div>

        {/* Grid */}
        <div className="vedios-grid">
          {currentVideos.map((v, index) => {
            const globalIndex = startIndex + index;
            const isPlaying = playingIndex === globalIndex;
            const videoId = extractVideoId(v.youtube);
            return (
              <div className="video-card" key={globalIndex}>
                <div className="videos">
                  {isPlaying ? (
                    <iframe
                      src={`${v.youtube}&autoplay=1`}
                      title={v.title}
                      allow="autoplay; encrypted-media"
                      allowFullScreen
                    ></iframe>
                  ) : (
                    <div
                      className="video-thumb"
                      onClick={() => setPlayingIndex(globalIndex)}
                    >
                      <img
                        src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
                        alt={v.title}
                      />
                      <div className="thumb-overlay-top">
                        <span className="channel-avatar">
                          {v.channel.charAt(0)}
                        </span>
                        <span className="channel-name">{v.channel}</span>
                      </div>
                      <div className="play-btn-wrap">
                        <div className="play-btn">▶</div>
                      </div>
                      <div className="thumb-overlay-bottom">
                        <span>👁 {v.views}</span>
                        <span>{v.time}</span>
                      </div>
                      <span className="video-duration">{v.duration}</span>
                    </div>
                  )}
                </div>

                <div className="video-info">
                  <div className="video-info-top">
                    <h4 className="ved-cap">Video {globalIndex + 1}</h4>
                    <div className="video-actions">
                      <button
                        className={`like-btn ${
                          likedVideos.includes(globalIndex) ? "liked" : ""
                        }`}
                        onClick={() => toggleLike(globalIndex)}
                      >
                        {likedVideos.includes(globalIndex) ? "❤" : "♡"}
                      </button>
                      <div className="menu-wrap">
                        <button
                          className="menu-btn"
                          onClick={() =>
                            setOpenMenuIndex(
                              openMenuIndex === globalIndex
                                ? null
                                : globalIndex
                            )
                          }
                        >
                          ⋮
                        </button>
                        {openMenuIndex === globalIndex && (
                          <div className="menu-dropdown">
                            <button>Share</button>
                            <button>Download</button>
                            <button>Report</button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <p className="video-title-text">{v.title}</p>
                  <div className="video-meta-row">
                    <span className="video-category-tag">{v.category}</span>
                    <span className="video-time">{v.time}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {filteredVideos.length === 0 && (
          <p className="no-results">No videos found.</p>
        )}

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="vg-pagination">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
            >
              ‹
            </button>
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
              <button
                key={p}
                className={currentPage === p ? "active" : ""}
                onClick={() => setCurrentPage(p)}
              >
                {p}
              </button>
            ))}
            <button
              disabled={currentPage === totalPages}
              onClick={() =>
                setCurrentPage((p) => Math.min(p + 1, totalPages))
              }
            >
              ›
            </button>
          </div>
        )}
      </div>
    </section>
  );
}

export default Mp4;